// Internal
import ComponentA from "./components/ComponentA";
import ComponentB from "./components/ComponentB";
import coverImage from "./assets/main-cover.jpg";
import "./style/style.css";

export default function App() {
  return (
    <div className="App">
      <header className="header">
        <img
          src={coverImage}
          alt="A warrior dressed in white fights again a warrior dressed in black, representing the chinesse Yin and Yang."
        />
        <h1 className="title">Handle State using React Hooks</h1>
      </header>

      <h2>Instructions:</h2>
      <p>
        Please open the browser console by rick clicking and choose Inspect
        element in Apple Safari or Inspect in Google Chrome.
      </p>
      <p>
        If you don't see the inspect element option in Safari{" "}
        <a
          href="https://support.apple.com/guide/safari/use-the-developer-tools-in-the-develop-menu-sfri20948/mac"
          rel="noreferrer"
          target="_blank"
        >
          click here{" "}
        </a>
        to learn how to enable it.
      </p>

      <section className="grid">
        <ComponentA />
        <ComponentB />
      </section>

      <footer>
        <h2>Note the following:</h2>
        <ul>
          <li>
            The value of Component A changes in the console but not on the web
            page. That's because we update the value but we never tell React to
            update the web page.
          </li>
          <li>
            The value of Component B changes in the console and on the webpage.
            But in addition, you see that Component B is recreated over and over
            each time you modify the value. This happens because React is
            destroying and recreating the component each time it updates the web
            page.
          </li>
          <li>
            Last detail for the people with keen eye. You can see that the
            console value of Component B is 1 number behind of what is show on
            the webpage. This is because React do not update the state
            immediately but it does a JavaScript Promise and those ones have a
            micro delay, so the <code>console.log()</code> runs before and then
            the webpage is updated when the Promise is return thus, having this
            small out of sync. But don't worry about it and if it gives you some
            sort of mental meltdown you can see how to solve by watching this{" "}
            <a
              href="https://www.youtube.com/watch?v=O6P86uwfdR0"
              rel="noreferrer"
              target="_blank"
            >
              video
            </a>
            .
          </li>
        </ul>
      </footer>
    </div>
  );
}
